import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {BackButton, Button, Container, Text, Title} from '../../components/@FreeModel';
import Header from '../../components/general/Header/Header';
import {useDispatch, useSelector} from "react-redux";
import {selectRegions} from "../../db/selectors";
import {gql, queryApplication, queryRegions, updateApplication, Region} from "../../db/model";
import {Checkbox, FormControlLabel, FormGroup, Accordion, AccordionSummary, AccordionDetails} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Mixpanel} from "../../observability/Mixpanel";


const BusinessInfoCoverageArea = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const regions = useSelector(selectRegions)
  const [selectAllItems, setSelectAllItems] = useState<Set<string>>(new Set())
  const [selectedItems, setSelectedItems] = useState<Set<string>>(new Set())
  const [loading, setLoading] = useState(true)

  const isValid = selectedItems.size > 0;

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplication,
      variables: {id: applicationID},
      onSuccess: (appState) => {
        setSelectedItems(new Set<string>(appState.application?.counties ?? []))

        // @ts-ignore
        dispatch(gql({
          query: queryRegions,
          usePublicHost: true,
          variables: {states: [appState.application?.homeState ?? '']},
          onSuccess: (_) => setLoading(false)
        }))
      }
    }))
  }, [dispatch, applicationID]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // @ts-ignore
    dispatch(gql({
      query: updateApplication,
      variables: {
        id: applicationID,
        form: {
          counties: Array.from(selectedItems),
        }
      },
      onSuccess: (_) => {
        Mixpanel.track("contractor-coverage-areas-added", {
          "invitation": applicationID,
        })
        navigate(`/contractors/${applicationID}/business-info/4`)
      }
    }))
  };

  if (loading) {
    return <div/>
  }

  const rows = []
  if (regions) {
    for (let i = 0; i < regions.length; i++) {
      const region = regions[i]

      const counties = []
      for (let c = 0; c < region.counties.length; c++) {
        const item = region.counties[c]

        const onChange = (isChecked: boolean, regionID: string) => {
          if (isChecked) {
            selectedItems.add(item.id)
          } else {
            selectedItems.delete(item.id)
            selectAllItems.delete(regionID)
          }
          setSelectedItems(new Set(selectedItems))
          setSelectAllItems(new Set(selectAllItems))
        }

        counties.push(<FormGroup key={item.id}>
          <FormControlLabel control={<Checkbox checked={selectedItems.has(item.id)}
                                               onChange={(event) => onChange(event.target.checked, region.id)}/>}
                                               label={item.name}/>
        </FormGroup>)
      }

      // Set single checkbox to select or deselect all ids
      const selectAll = (isChecked: boolean, r: Region) => {
        if (isChecked) {
          selectAllItems.add(r.id)
          r.counties.forEach(county => {
            selectedItems.add(county.id)
          })
        } else {
          selectAllItems.delete(r.id)
          r.counties.forEach(county => {
            selectedItems.delete(county.id)
          })
        }
        setSelectedItems(new Set(selectedItems))
        setSelectAllItems(new Set(selectAllItems))
      }

      counties.unshift(<FormGroup key={`select-all-${region.id}`}>
        <FormControlLabel control={<Checkbox checked={selectAllItems.has(region.id)}
                          onChange={(event) => selectAll(event.target.checked, region)}/>}
                          label={<Text weight="bold">Select All</Text>}
        />
      </FormGroup>)

      rows.push(<Accordion>
        <AccordionSummary
          key={region.id}
          expandIcon={<ExpandMoreIcon />}
        >
        <Text weight="bold">{region.name}</Text>
        </AccordionSummary>
        <AccordionDetails>
          {counties}
        </AccordionDetails>
      </Accordion>)
    }
  }

  return (
    <Container>
      <Header title="Add Business Info"/>
      <BackButton to={`/contractors/${applicationID}/business-info/2`}/>
      <br/>

      <Title weight="bold" color="orange" lineHeight="lg">
        Select Coverage Area
      </Title>
      <Text color="gray">Which of the following areas does your business serve? (Select all that apply)</Text>
      <br/>

      {rows}

      <form onSubmit={handleSubmit}>
        <br/>
        <br/>
        <Button disabled={!isValid}>Continue</Button>
      </form>
    </Container>
  );
};

export default BusinessInfoCoverageArea;
